/*
 * Copyright 2026, IntraLinks, Inc. All rights reserved.
 */

/**
 * Nulls `window.opener` as early as possible for LoA popup windows.
 *
 * Prevents reverse tabnabbing / opener-based navigation of the parent window it
 * the popup redirects to a third-party origin during the LoA flow.
 */
export default function nullifyOpenerIfLoaPopup(): void {
  try {
    const q = new URLSearchParams(window.location.search);
    const isPopupMode = q.get('mode') === 'popup';
    const isPopupName = window.name === 'loa-elevation';

    if (isPopupMode || isPopupName) {
      window.opener = null;
    }
    // eslint-disable-next-line no-empty
  } catch { }
}
